import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import AnttDropdown from "../../../../vendors/components/Dropdown";
import React, { useEffect, useRef, useState } from "react";
import PortalController from "../controller/portal.controller";
import {
  ativarLayoutEventoInterno,
  idDoEvento,
  isEventoInterno,
} from "../../../shared/utils/EventoInternoUtil";
import "../assets/portal.scss";
import "../../DefaultPage/ConsultarEventos/assets/consultar-eventos.scss";
import AnttButton from "../../../../vendors/components/Button";
import { Paginator } from "primereact/paginator";
import { EventoOrdenacaoConstants } from "../../../shared/utils/EventoOrdenacaoConstants";
import ModalLogin from "../../../components/modal-login";
import { InputMask } from "primereact/inputmask";
import { OverlayPanel } from "primereact/overlaypanel";
import { ShareModal } from "../../../components/ShareModal/ShareModal";
import EventoResultadoItem from "../../DefaultPage/ConsultarEventos/components/EventoResultadoItem";

export default function Portal() {
  const controller = new PortalController();
  const filter = controller.filter;
  const ordenacaoList = EventoOrdenacaoConstants.LISTA;
  const shareModalRef = useRef<OverlayPanel>(null);
  const [currentShareUrl, setCurrentShareUrl] = useState("");

  useEffect(() => {
    controller.init();
  }, []);

  const click = (row: any) => {
    const id = idDoEvento(row);
    if (isEventoInterno(row)) {
      sessionStorage.setItem("idEventoInterno", String(id));
      ativarLayoutEventoInterno();
      controller.history.push("/evento-interno", { id });
      return;
    }
    if (!controller.isAuthenticated()) {
      controller.history.push("/public/evento/visualizar", { id });
    } else {
      controller.history.push("/evento/visualizar", { id });
    }
  };

  const compartilhar = async (row: any, e: React.MouseEvent) => {
    const link = await controller.getEvento(idDoEvento(row));
    setCurrentShareUrl(link);
    shareModalRef.current?.toggle(e);
  };

  return (
    <>
      <Card className="ce-resultados">
        <form
          className="portal-pesquisa"
          onSubmit={(e) => {
            e.preventDefault();
            e.stopPropagation();
            controller.setLazyParams({
              ...controller.lazyParams,
              page: 0,
              first: 0,
            });
            controller.consultarFiltro();
          }}
        >
          <h2 className="portal-pesquisa-titulo">Consultar Eventos</h2>
          <div className="portal-pesquisa-campos">
            <div className="portal-pesquisa-campo">
              <label htmlFor="portal-busca">Busca</label>
              <InputText
                id="portal-busca"
                maxLength={100}
                placeholder="Digite uma palavra-chave para pesquisa no campo objeto (ex: BR-153, frete…)"
                value={filter.busca}
                onChange={(e) => filter.setBusca(e.target.value)}
              />
            </div>
            <div className="portal-pesquisa-campo">
              <label htmlFor="portal-numero">Número</label>
              <InputMask
                id="portal-numero"
                mask="999999999"
                autoClear={false}
                slotChar=""
                value={filter.numeroAudiencia}
                onChange={(e) => filter.setNumeroAudiencia(e.target.value)}
              />
            </div>
            <div className="portal-pesquisa-campo">
              <label htmlFor="portal-ano">Ano</label>
              <AnttDropdown
                inputId="portal-ano"
                options={controller.anoList}
                optionLabel="descricao"
                optionValue="codigo"
                value={filter.codigoAno}
                onChange={(e) => filter.setCodigoAno(e.value)}
              />
            </div>
          </div>
          <div className="portal-pesquisa-acoes">
            <AnttButton type="submit" label="Consultar" icon="pi pi-search" />
            <AnttButton
              type="button"
              icon="pi pi-times"
              className="p-button-secondary"
              label="Limpar"
              onClick={() => controller.limpar()}
            />
          </div>
        </form>
      </Card>
      <Card className="ce-resultados">
        <div className="ce-resultados-topo">
          <div>
            <h2 className="ce-resultados-titulo">Eventos em andamento</h2>
            <span className="ce-resultados-total">
              {controller.total} {controller.total === 1 ? "evento encontrado" : "eventos encontrados"}
            </span>
          </div>
          <div className="ce-ordenar">
            <label htmlFor="ordenar-eventos-home">Ordenar por</label>
            <AnttDropdown
              inputId="ordenar-eventos-home"
              options={ordenacaoList}
              showClear={false}
              optionLabel="label"
              optionValue="value"
              value={filter.ordering}
              placeholder="Organizar por"
              onChange={(e) => {
                filter.setOrdering(e.value);
                controller.consultar(
                  0,
                  10,
                  !controller.temFiltroUsuario(),
                  null,
                  e.value
                );
              }}
            />
          </div>
        </div>
        {controller.lista.length > 0 && (
          <div className="ce-colunas">
            <span>Evento</span>
            <span>Objeto</span>
            <span>Situação do evento</span>
            <span>Ações</span>
          </div>
        )}
        <div className="ce-lista">
          {controller.lista.map((evento: any, index: number) => (
            <EventoResultadoItem
              key={`portal-evento-${evento.id || evento.codAudienciaPublica || index}`}
              evento={evento}
              onAcessar={click}
              onCompartilhar={compartilhar}
            />
          ))}
          {controller.lista.length <= 0 && (
            <div className="ce-vazio">
              <i className="pi pi-inbox" />
              <span>Nenhum registro encontrado</span>
            </div>
          )}
        </div>
        <div className="ce-paginacao">
          <div className="ce-paginacao-item">
            <Paginator
              rows={controller.lazyParams.rows}
              first={controller.lazyParams.first}
              totalRecords={controller.total}
              onPageChange={(e: any) => controller.onPage(e)}
              rowsPerPageOptions={[10, 20, 30, 40, 50]}
            />
          </div>
        </div>
        <ShareModal ref={shareModalRef} url={currentShareUrl} />
      </Card>
      <ModalLogin
        visible={controller.visibleLogin}
        dispositivoLogin={{}}
        onHide={() => controller.setVisibleLogin(false)}
      />
    </>
  );
}
